import React from "react";
import {StepBadge} from "@/components/Modals/LoginOrRegistrationModal/StepBadge";

export type StepRowProps = {
    step: number;
    title: React.ReactNode;
    children?: React.ReactNode;
};
export const StepRow: React.FC<StepRowProps> = ({step, title, children}) => {
    return (
        <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-[36px_1fr] md:gap-x-6 md:gap-y-[18px]">
            <div className="hidden md:block">
                <StepBadge step={step}/>
            </div>

            <div className="min-w-0">
                <div className="mb-3 flex items-start gap-3 md:mb-0 md:block">
                    <div className="md:hidden">
                        <StepBadge step={step}/>
                    </div>
                    <div className="text-[20px] font-medium leading-[24px] text-[#1f1f1f]">{title}</div>
                </div>

                {children ? <div className="mt-4 md:mt-[18px]">{children}</div> : null}
            </div>
        </div>
    );
};